import { JobseekerService } from '../shared/services/jobseeker.service';
import { DocumentTypeEnum } from '../shared/models/document-type-enum';
import { JobseekerFile } from '../shared/models/jobseeker-file';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-jobseeker-uploaded-document-item',
  templateUrl: './jobseeker-uploaded-document-item.component.html',
  styleUrls: ['./jobseeker-uploaded-document-item.component.less'],
  standalone: false,
})
export class JobseekerUploadedDocumentItemComponent implements OnInit {
  @Input()
  public document: JobseekerFile;
  public documentTypeEnum: DocumentTypeEnum;
  public DocumentTypeEnum: any = DocumentTypeEnum;

  @Output()
  public onUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();
  public dateFormat: string;

  constructor(
    private jobseekerService: JobseekerService,
    private translateService: TranslateService,
    private config: ConfigurationService
  ) {}

  public getDownloadUrl() {
    return this.jobseekerService.getUploadedDocumentDownloadUrl(
      this.document.jobseekerId,
      this.document.jobseekerDocumentId
    );
  }

  public onDownloadUploadedDocumentClick(formId: string) {
    let form = <any>document.getElementById(formId);
    form.submit();
  }

  public onDeleteUploadedDocumentClick() {
    if (confirm(this.translateService.instant('message.AreYouSure'))) {
      this.jobseekerService
        .DeleteUploadedDocument(
          this.document.jobseekerId,
          this.document.jobseekerDocumentId
        )
        .subscribe((r) => {
          this.onUpdate.emit(true);
        });
    }
  }

  ngOnInit() {
    let config = this.config.getCachedConfig();
    this.dateFormat = config.dateFormat;
  }
}
